var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 31.6922C24.6177 32.6443 11.8091 37.7449 5.62446 45.5998L5.62996 45.5802C7.18762 40.0267 10.8179 27.0836 1.4 11.7998C11.7415 21.695 12.9581 22.4771 28.2 31.6922Z",
    fill: "url(#paint0_radial_444_2289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45.6004C38.6472 25.7508 39.5491 19.157 43.2568 2.40039C34.238 24.1194 22.0125 31.291 0 9.02824C17.2693 28.0961 26.7223 26.1247 48 45.6004Z",
    fill: "url(#paint1_radial_444_2289)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_444_2289",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2736 31.0801) rotate(140.335) scale(26.9561 21.5301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_444_2289",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 24.0004) rotate(90) scale(28.2279 31.3643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.3c3686b4d7c5439a247cca9a1e7958c9.svg";
export { ForwardRef as ReactComponent };